import { ObjectMapper } from "json-object-mapper";
import { IModel } from "../IModel";
import { Model } from "../model";
import { PipeLineAction } from "./enum/PipeLineAction.enum";

export class RecruitPipelineAction extends Model implements IModel<RecruitPipelineAction> {
    public pipelineConfigId?: string = undefined;
    public action: string = "";
    public enable: boolean = true;
    
    deserialize(input: any): RecruitPipelineAction {
        if (!input) {
            return this;
        }

        Object.assign(this, input);

        if (input.action !== undefined) {
            this.action = PipeLineAction.resolveValue(input.action);
        }

        return this;
    }

    serialize(): any {
        const obj: any = {};

        if (this.id && this.id !== '00000000-0000-0000-0000-000000000000') {
            obj.id = this.id;
        }

        if (this.action) {
            obj.action = PipeLineAction.getBy(this.action)?.id ?? this.action;
        }

        obj.enable = this.enable !== false;

        return obj;
    }

    public get actionData(): PipeLineAction | undefined {
        if (!this.action) {
            return undefined;
        }
        return PipeLineAction.getBy(PipeLineAction.resolveValue(this.action));
    }

    public static fromArray(input: any[]): RecruitPipelineAction[] {
        if (!input || !Array.isArray(input)) {
            return [];
        }
        return input.map(item => new RecruitPipelineAction().deserialize(item));
    }
}

